import { useCallback, useEffect, useState } from 'react';
import { coreApi } from '../../../utils/axios';
import { WebsiteConfiguration } from '../types/websiteConfiguration';
import { prepareForRender } from '../utils/format';
import errorRoutine from '../../../utils/errorRoutine';

export const useWebsiteConfiguration = (orgId: string) => {
  const [config, setConfig] = useState<WebsiteConfiguration>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const fetch = useCallback(async () => {
    try {
      setIsLoading(true);

      const { data } = await coreApi.get<{ data: WebsiteConfiguration[] }>(`/website-configurations?organisationId=${orgId}`);
      const fetchedConfig = data.data[0];

      setConfig(prepareForRender(fetchedConfig));
    } catch (err) {
      errorRoutine(err, setError);
    } finally {
      setIsLoading(false);
      setIsLoaded(true);
    }
  }, [orgId]);

  useEffect(() => {
    fetch();
  }, [orgId, fetch]);

  return { config, isLoading, isLoaded, error, setConfig };
};
